import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/**
 * CollabStatus — sticky footer showing connection status and character count.
 */
const CollabStatus = ({ status, activeUsers = [], editor, t }) => {
  const theme = useTheme();

  return (
    <Box
      className="collab-status"
      sx={{
        position: 'sticky',
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1,
        borderTop: `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
        flexShrink: 0,
      }}
      data-state={status === 'connected' ? 'online' : 'offline'}
    >
      <Typography variant="caption" color="text.secondary">
        {status === 'connected'
          ? t(activeUsers.length === 1 ? 'document_editor.user_online_one' : 'document_editor.users_online_many', { count: activeUsers.length })
          : t('document_editor.offline_reconnecting')}
      </Typography>

      {editor?.storage?.characterCount && (
        <Typography variant="caption" color="text.secondary">
          {editor.storage.characterCount.characters()} {t('document_editor.characters')}
        </Typography>
      )}
    </Box>
  );
};

export default CollabStatus;
